(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapacomparativoController', MapacomparativoController);

    MapacomparativoController.$inject = ['Safra','DataUtils', 'Mapaimagem', 'MapaimagemSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade'];

    function MapacomparativoController(Safra, DataUtils, Mapaimagem, MapaimagemSearch, ParseLinks, AlertService, paginationConstants, Propriedade) {

        var vm = this;
        vm.mapaimagems = [];
        vm.typeMap = typeMap;
        vm.showMaps = showMaps;
        vm.clear = clear;
        vm.download = download;
        vm.sucessoDownload = sucessoDownload;
        vm.pressButtonMaps = pressButtonMaps;
        vm.tipoMapa = "";
        vm.textMaps = "";
        vm.safra = new Safra();
        vm.propriedade = null;
        vm.tipoNutricional = "Nitrogênio";
        vm.typeMap('Percevejo');
        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 100  
        });
        vm.loadPage = loadPage;
        vm.itemsPerPage = 20;
        vm.page = 0;
        vm.links = {
            last: 0
        };

        vm.safras = [];
        vm.onSucessoSafra = onSucessoSafra;


        vm.changePropriedade = function () {
            console.log("Change propriedade!");
            vm.safras = [];
            Safra.querySafraIdNome({size:1000}, vm.onSucessoSafra);
        }

        function onSucessoSafra(result){
            console.log(result);
            for (var i = 0; i < result.length; i++) {
                if(result[i].propriedade_id === parseInt(vm.propriedade.id)){
                    console.log("Added safra!");
                    vm.safras.push(result[i]);
                }
            }
        }

        function typeMap(tipoMapa) {
            console.log("typeMap " + tipoMapa);
            vm.tipoMapa = tipoMapa;
            console.log(vm.tipoNutricional);
            console.log("safra " + vm.safra.nomesafra);
            vm.clear();
        }

        function pressButtonMaps(){
            console.log("press " + vm.safra.nomesafra);
            vm.clear();
            vm.showMaps();
        }

        function showMaps() {
            console.log("showmap");
            if (vm.tipoMapa == "Nutricional") {
                console.log("nut");
                Mapaimagem.queryComparativoNutricional({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    safraid: vm.safra.id,
                    busca: vm.tipoNutricional
                },onSuccess,onError)
            }
            else {
                console.log("outros " + vm.tipoMapa);
                Mapaimagem.queryComparativoPragaSaude({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    safraid: vm.safra.id,
                    busca: vm.tipoMapa
                },onSuccess,onError)
            }
               
            function onSuccess(data, headers) {
                if (data.length == 0){
                    vm.textMaps = "Não existem mapas para serem exibidos";
                }
                console.log(data);
                console.log("sucesso");
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    if(vm.propriedade === null){
                        console.log("Added!");
                        data[i].imagempequenaContentType = 'data:' + data[i].imagempequenaContentType +';base64,' + data[i].imagempequena;
                        vm.mapaimagems.push(data[i]);
                    }
                    else{
                        if(data[i].propriedade_id === parseInt(vm.propriedade.id)){
                            console.log("Added!");
                            data[i].imagempequenaContentType = 'data:' + data[i].imagempequenaContentType +';base64,' + data[i].imagempequena;
                            vm.mapaimagems.push(data[i]);
                        }
                    }
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function loadPage(page) {
            vm.page = page;
            showMaps();
        }

        function clear () {
            vm.textMaps = "";
            vm.mapaimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
        }
        function download(id){
            
            Mapaimagem.queryImagem({mapaid: id}, vm.sucessoDownload);
            
        }
        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }
        function sucessoDownload(data){
            var filename = 'mapa';
            console.log("SUCESSO");
            var ct = data[0].imagemContentType;
            var dados = data[0].imagem;
            
            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }
    }
})();
